<nav
  class="fixed top-0 left-0 right-0 z-80 h-16 flex justify-between px-3 transition duration-200"
  [class.backdrop-blur-3xl]="scrolled() && !navOpen()"
  [class.border-b]="scrolled() && !navOpen()"
  [class.border-white/10]="scrolled() && !navOpen()"
>
  <button
    class="fixed 2xl:hidden top-1 left-1 z-60 gap-3 p-3 rounded-2xl text-input-foreground hover:bg-white hover:text-gray-900 hover:shadow-sm transition flex items-center group cursor-pointer"
    aria-label="Abrir menú"
    [class.text-black]="scrolled()"
    (click)="navOpen.set(!navOpen())"
  >
    <div class="w-10 h-10 rounded-full flex items-center justify-center">
      <app-svg-menu-close class="w-8 h-8" [ngClass]="{ hidden: !navOpen() }" />
      <app-svg-menu
        class="w-8 h-8 stroke-white group-hover:stroke-[#292D32]"
        [ngClass]="{ hidden: navOpen() }"
      />
    </div>
    <span>{{ navOpen() ? 'Cerrar' : 'Menú' }}</span>
  </button>
  <div
    class="fixed inset-0 z-40 2xl:hidden bg-black/50 backdrop-blur-lg transition-opacity duration-300 ease-out opacity-0"
    tabindex="0"
    role="button"
    [class.opacity-100]="navOpen()"
    [class.pointer-events-auto]="navOpen()"
    [class.pointer-events-none]="!navOpen()"
    (click)="onOverlayClick($event)"
    (keydown.escape)="navOpen.set(false)"
  ></div>
  <div
    class="2xl:hidden fixed top-0 left-0 z-50 h-dvh w-64 p-4 flex flex-col text-input-foreground transform-gpu will-change-transform transition-transform duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] -translate-x-full"
    [class.translate-x-0]="navOpen()"
  >
    <div class="mt-18 flex flex-col gap-2">
      @for (item of items; let i = $index; track i) {
        <button
          class="flex items-center gap-3 p-3 rounded-2xl cursor-pointer transition top-0"
          [routerLink]="item.route"
          [routerLinkActiveOptions]="{ exact: false }"
          (click)="onMenuClick(i); navOpen.set(false)"
          routerLinkActive="bg-white text-gray-900 shadow-sm"
        >
          <div
            class="shrink-0 w-10 h-10 rounded-full flex items-center justify-center {{
              item.bg
            }} text-gray-900"
          >
            <ng-icon [name]="item.icon" />
          </div>
          <span class="text-left">{{ item.label }}</span>
        </button>
      }
    </div>

    <div class="mt-auto pt-4 cursor-pointer">
      <app-custom-select
        [(ngModel)]="themeMode"
        [options]="themeOptions()"
        [showUnderline]="false"
        [label]="''"
        (ngModelChange)="onThemeModelChange($event)"
        containerClass="w-full"
        buttonClass="flex items-center gap-3 p-3 rounded-2xl cursor-pointer transition text-input-foreground hover:bg-white hover:text-gray-900 hover:shadow-sm"
        valueClass="text-left"
        panelClass="mt-2 w-[260px] max-w-[calc(100vw-2rem)] rounded-2xl border border-gray-200 bg-white shadow-lg overflow-hidden"
      >
        <div
          class="shrink-0 w-10 h-10 rounded-full flex items-center justify-center bg-[#d9c2f3] text-gray-900"
          select-prefix
        >
          <ng-icon [name]="themeIcon()" />
        </div>
      </app-custom-select>
    </div>
  </div>

  <!-- Sidebar desktop -->
  <div class="hidden 2xl:flex fixed flex-col gap-2 w-64 p-4 text-input-foreground">
    @for (item of items; let i = $index; track i) {
      <a
        class="flex items-center gap-3 p-3 rounded-2xl cursor-pointer transition"
        [routerLink]="item.route"
        [routerLinkActiveOptions]="{ exact: false }"
        (click)="onMenuClick(i)"
        routerLinkActive="bg-cyan-600 dark:bg-white shadow-sm text-gray-900"
      >
        <div
          class="shrink-0 w-10 h-10 rounded-full flex items-center justify-center {{
            item.bg
          }} text-gray-900"
        >
          <ng-icon [name]="item.icon" />
        </div>
        <span>{{ item.label }}</span>
      </a>
    }
  </div>

  <!-- Logout -->
  <div class="flex fixed items-center top-1 right-1 z-60 gap-3">
    <div class="relative w-35" [attr.aria-label]="themeLabel()" [title]="themeLabel()">
      <app-custom-select
        [(ngModel)]="themeMode"
        [options]="themeOptions()"
        (ngModelChange)="onThemeModelChange($event)"
        containerClass="w-full bg-transparent p-1 outline-none md:text-base hidden md:block cursor-pointer"
      >
        <ng-icon
          class="w-5 h-5 mr-1"
          [class.text-input-foreground]="isDarkMode()"
          [class.text-gray-900]="!isDarkMode()"
          [name]="themeIcon()"
          select-prefix
        />
      </app-custom-select>
    </div>
    <button
      class="p-3 flex row items-center rounded-2xl cursor-pointer transition text-input-foreground hover:bg-white hover:text-gray-900 hover:shadow-sm group"
      (click)="logout()"
    >
      <div class="w-10 h-10 rounded-full flex items-center justify-center">
        <app-svg-logout />
      </div>
      <span>Cerrar sesión</span>
    </button>
  </div>
</nav>
